module.exports = __webpack_public_path__ + "img/升级弹窗新_03.348daff5.png";